// The id of the build THIS bundle came from, injected by vite.config's
// `define` (see "aurora-version-json" there). The same id is published as
// /version.json in the same deployment; comparing the two detects a tab
// running an older bundle than the one currently deployed.
//
// `typeof` guard: environments where the define isn't applied (vitest unit
// tests, tooling) read "dev" instead of throwing ReferenceError.
declare const __AURORA_BUILD_ID__: string | undefined;

export const BUILD_ID: string =
  typeof __AURORA_BUILD_ID__ === "string" ? __AURORA_BUILD_ID__ : "dev";

/** The build id the SERVER is currently deploying, from /version.json (same
 *  origin, emitted by the build). Null when unknowable — version.json absent
 *  (vite dev serves no build artifacts), network failure, or a non-JSON
 *  response (e.g. an expired CF Access session answering with its login
 *  page) — and null never triggers the stale banner.
 *
 *  The cache-busting query forces a distinct URL so neither the browser cache
 *  nor the CF edge can hand back a copy from the OLD deployment. */
export async function fetchServedBuildId(): Promise<string | null> {
  try {
    const r = await fetch(`/version.json?_=${Date.now()}`, { cache: "no-store" });
    if (!r.ok) return null;
    const body: unknown = await r.json();
    const build = (body as { build?: unknown }).build;
    return typeof build === "string" && build ? build : null;
  } catch {
    return null;
  }
}
